<template>
  <v-card flat class="pa-0 ma-0"
          :style="$vuetify.breakpoint.smAndDown ? 'background-color: transparent; overflow: unset' : 'overflow: unset'">
    <v-layout row wrap>
      <v-flex xs12>
        <v-autocomplete
            id="postalCode"
            clearable
            hide-selected
            v-model="postalcode"
            :items="postalCodes"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            :rules="[postalCodeRules]"
            :label="$lang.labels.postalCode"
            :placeholder="$lang.labels.startTyping"
            :hint="hint"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pr-1">
        <v-autocomplete
            id="line1"
            clearable
            hide-selected
            validate-on-blur
            :loading="isLoadingAddress"
            :search-input="searchLine1"
            v-model="line1"
            :items="addressesResultFiltered"
            :item-text="line1 ? 'line1' : (v) => generateAddress(v)"
            item-value="line1"
            hide-no-data
            :rules="[(v) => addressesResultFiltered.map(y => y.line1).includes(v) || showError('line1')]"
            :label="$lang.labels.line1"
            :placeholder="addressesResultFiltered && addressesResultFiltered.length > 0 ? $lang.labels.startTyping : 'Nothing to search'"
            @focus="line1 = null; addressLookup(postalcode)"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pl-1">
        <v-autocomplete
            id="line2"
            clearable
            hide-selected
            v-model="line2"
            :search-input.sync="searchLine2"
            :items="addressesLine2"
            hide-no-data
            :label="$lang.labels.line2"
            :placeholder="addressesLine2 && addressesLine2.length > 0 ? $lang.labels.startTyping : 'Nothing to search'"
            @blur="onBlurLine2()"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pr-1">
        <v-autocomplete
            id="line3"
            clearable
            hide-selected
            v-model="line3"
            :search-input.sync="searchLine3"
            :items="addressesLine3"
            hide-no-data
            :label="$lang.labels.line3"
            :placeholder="addressesLine3 && addressesLine3.length > 0 ? $lang.labels.startTyping : 'Nothing to search'"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pl-1">
        <v-text-field
            id="line4"
            v-model="line4"
            :label="$lang.labels.line4"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 sm6 class="pr-1">
        <v-autocomplete
            id="townCity"
            clearable
            hide-selected
            v-model="townCity"
            :items="addressesTownCity"
            hide-no-data
            validate-on-blur
            :rules="[(v) => addressesTownCity.includes(v) || showError('townCity')]"
            :label="$lang.labels.townCity"
            :placeholder="addressesTownCity && addressesTownCity.length > 0 ? $lang.labels.startTyping : 'Nothing to search'"
        ></v-autocomplete>
      </v-flex>

      <v-flex xs12 sm6 class="pl-1">
        <v-text-field
            id="locality"
            v-model="locality"
            :label="$lang.labels.locality"
        ></v-text-field>
      </v-flex>
      <p style="display: none !important;">{{ isValid }}</p>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AddressLookupUK',
  props: ['address', 'fromBack'],
  data: () => ({
    isLoadingAddress: false,
    isLoading: false,
    showNav: false,
    orderType: '',
    fullAddress: null,
    postalcode: '',
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    townCity: '',
    locality: '',
    comment: '',
    err: '',
    warn: '',
    success: '',
    successPostal: '',
    deliveryCharges: null,
    distanceInMiles: 0,
    total: 0,
    itemsTotal: 0,
    validPostal: null,
    selectAddress: null,
    selectAddressAT: null,
    calcTimeout: null,
    latitude: null,
    longitude: null,
    resourceId: null,
    postalCodes: [],
    search: null,
    searchLine1: null,
    searchLine2: null,
    searchLine3: null,
    searchTownCity: null,
    searchAddress: null,
    hint: '',
    showAddressFields: false,
    addressesResultFull: [],
    addressesResultFiltered: [],
    country: null,
    init: false,
  }),
  computed: {
    ...mapGetters({
      postalCode: 'postalCode',
      company: 'company',
      goDark: 'goDark',
    }),
    postalCodeRules() {
      if (this.country && this.postalcode) {
        return this.testPostalCodeRules(this.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    addressesLine1() {
      return this.filterUniqueFields(this.addressesResultFull, 'line1');
    },
    addressesLine2() {
      return this.filterUniqueFields(this.addressesResultFiltered.filter(
        x => x.line1 === this.line1,
      ), 'line2');
    },
    addressesLine3() {
      return this.filterUniqueFields(this.addressesResultFiltered.filter(
        x => x.line1 === this.line1,
      ), 'line3');
    },
    addressesTownCity() {
      return this.filterUniqueFields(this.addressesResultFiltered, 'townCity');
    },
    isValid() {
      const valid = this.addressesResultFull.find(x => x.postalCode === this.postalcode
          && x.line1 === this.line1
          && x.townCity === this.townCity);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (valid) {
        this.fullAddress = valid;
        this.$emit('submit', this.fullAddress);
      }
      if (!valid) this.fullAddress = null;
      return !!valid;
    },
  },
  watch: {
    fullAddress: {
      handler(val) {
        if (val) {
          this.line1 = val.line1;
          this.line2 = val.line2;
          this.line3 = val.line3;
          this.line4 = val.line4;
          this.townCity = val.townCity;
          this.locality = val.locality;
          this.latitude = val.latitude;
          this.longitude = val.longitude;
        }
      },
      deep: true,
    },
    search: {
      handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        if (this.init) {
          this.searchLine1 = '';
          this.addressesResultFull = [];
          this.addressesResultFiltered = [];
          this.getPostalCodes(val);
        }
      },
      deep: true,
    },
    postalcode() {
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
      if (this.testPostalCodeRules(this.country, this.postalcode) === true && this.init) {
        setTimeout(() => {
          setTimeout(() => {
            document.getElementById('line1')
              .click();
            document.getElementById('line1')
              .focus();
          }, 50);
        }, 50);
        this.line1 = null;
        this.searchLine1 = null;
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
      }
    },
    line1() {
      if (!this.line1 && this.init) {
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
        this.addressesResultFiltered = this.addressesResultFull;
      }
      if (this.line1 && this.init) {
        this.addressesResultFiltered = this.addressesResultFull.filter(
          x => x.line1 === this.line1,
        );
        if (this.addressesResultFiltered.length === 1) {
          setTimeout(() => {
            this.fullAddress = this.addressesResultFiltered[0];
            document.getElementById('line2')
              .click();
            document.getElementById('line2')
              .focus();
          }, 50);
        }
      }
    },
    line2() {
      if (!this.line2 && this.init) {
        this.line3 = null;
        this.addressesResultFiltered = this.addressesResultFull;
      }
      if (this.line2 && this.init) {
        if (this.addressesResultFiltered.filter(x => x.line1 === this.line1).length === 1) {
          setTimeout(() => {
            this.line3 = this.addressesResultFiltered[0].line3;
            document.getElementById('line2')
              .blur();
            document.getElementById('line3')
              .click();
            document.getElementById('line3')
              .focus();
          }, 50);
        }
        if (this.filterUniqueFields(this.addressesResultFiltered, 'townCity').length === 1) {
          this.townCity = this.filterUniqueFields(this.addressesResultFiltered, 'townCity')[0];
        }
      }
    },
    line3() {
      if (!this.line3 && this.init) {
        this.addressesResultFiltered = this.addressesResultFull;
      }
      if (this.line3 && this.init) {
        if (this.filterUniqueFields(this.addressesResultFiltered, 'townCity').length === 1) {
          this.townCity = this.filterUniqueFields(this.addressesResultFiltered, 'townCity')[0];
        }
        document.getElementById('line3')
          .blur();
        document.getElementById('townCity')
          .click();
        document.getElementById('townCity')
          .focus();
      }
    },
  },
  methods: {
    showError(line) {
      this.startErrorAnimation(line);
      return 'Required!';
    },
    startErrorAnimation(elementId) {
      const el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(() => {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    filterAddresses(value, target) {
      if (this.addressesResultFull.length === 0) return;
      if (!value) {
        this.addressesResultFiltered = this.addressesResultFull;
        return;
      }
      if (target === 'line2' && this.line1 !== '') {
        this.addressesResultFiltered = this.addressesResultFull.filter((address) => {
          if (address[target] && address.line1 === this.line1) return address;
          return false;
        });
        return;
      }
      this.addressesResultFiltered = this.addressesResultFull.filter((address) => {
        if (address[target] && address[target].toLowerCase()
          .includes(value.toLowerCase()
            .trim())) {
          return address;
        }
        return false;
      });
    },
    generateAddress(input) {
      // if (this.line1) return input.line1;
      let address = '';
      const tempKeys = Object.keys(input);
      tempKeys.forEach((key, index) => {
        if (['latitude', 'longitude', 'country'].includes(key)) {
          address += '';
        } else if (input[key]) address += tempKeys.length !== index - 1 ? `, ${input[key].trim()}` : `${input[key].trim()}`;
      });
      address = address.substring(2, address.length);
      return address;
    },
    moveToHouseNo() {
      document.getElementById('line1')
        .blur();
      document.getElementById('line2')
        .click();
      document.getElementById('line2')
        .focus();
    },
    getPostalCodes(code) {
      if (!this.init) return;
      if (!code) return;
      code.trim()
        .toUpperCase();
      this.hint = '';
      if (this.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      this.isLoading = true;
      this.$webHelper.get(`address/postalcodes/${this.resourceId}`, {
        startswith: code.trim()
          .toUpperCase(),
      })
        .then((res) => {
          if (res.data && res.status === 200) {
            if (res.data.postalCodes.length === 0) {
              this.hint = this.$lang.errors.noPostalFound;
              this.isLoading = false;
            } else {
              this.postalCodes = res.data.postalCodes;
              this.line1 = '';
              this.searchLine1 = '';
              if (res.data.postalCodes.length === 1) {
                this.postalcode = this.postalCodes[0];
              }
              this.isLoading = false;
            }
          }
        })
        .catch((err) => {
          this.err = err;
          this.isLoading = false;
        });
    },
    addressLookup(value) {
      if (!this.init) return;
      if (!value) return;
      if (this.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      this.isLoadingAddress = true;
      // this.addressesResultFull = [];
      // this.addressesResultFiltered = [];
      const payload = {
        postalCode: value.trim()
          .toUpperCase(),
        country: this.country,
      };
      this.$webHelper.post(`address/${this.resourceId}`, payload)
        .then((res) => {
          if (res.data && res.status === 200 && res.data.addresses) {
            this.hint = this.$lang.success.postalSet;
            this.addressesResultFull = res.data.addresses || [];
            this.addressesResultFiltered = res.data.addresses || [];
            this.isLoadingAddress = false;
          } else {
            this.hint = res.data.statusText;
            this.isLoadingAddress = false;
          }
        })
        .catch((err) => {
          this.err = err;
          this.isLoadingAddress = false;
        });
    },
    testPostalCodeRules(countryToCheck, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!countryToCheck) return this.$lang.errors.countryRequired;
      if (countryToCheck === 'UK') {
        return zip.length > 5 && zip.length < 16;
      }
      if (countryToCheck === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    onBlurLine2() {
      if (this.searchLine2 && this.addressesLine2.includes(this.searchLine2.toUpperCase())) {
        this.line2 = this.searchLine2.toUpperCase();
      }
    },
    onBlurLine3() {
      if (this.searchLine3 && this.addressesLine3.includes(this.searchLine3.toUpperCase())) {
        this.line3 = this.searchLine3.toUpperCase();
      }
    },
    filterUniqueFields(addresses, property) {
      if (addresses && addresses.length > 0) {
        let filteredFieldList = addresses.map(address => address[property]);
        // eslint-disable-next-line max-len
        filteredFieldList = filteredFieldList.filter((item, index) => filteredFieldList.indexOf(item) === index)
          .filter(x => x !== undefined)
          .sort();
        return filteredFieldList;
      }
      return [];
    },
  },
  mounted() {
    this.country = this.company && this.company.address ? this.company.address.country : null;
  },
  created() {
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (this.address) {
      this.fullAddress = { ...this.address };
      this.addressesResultFull = [this.address];
      this.addressesResultFiltered = [this.address];
      this.postalCodes = [this.address.postalCode] || [];
      this.postalcode = this.address.postalCode;
      this.searchLine1 = this.address.line1;
      this.line1 = this.address.line1;
      this.searchLine2 = this.address.line2;
      this.line2 = this.address.line2;
      this.line3 = this.address.line3;
      this.townCity = this.address.townCity;
      setTimeout(() => {
        this.init = true;
      }, 100);
    } else {
      this.init = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.ahashakeheartache {
  -webkit-animation: kf_shake 0.4s 1 linear;
  -moz-animation: kf_shake 0.4s 1 linear;
  -o-animation: kf_shake 0.4s 1 linear;
}
@-webkit-keyframes kf_shake {
  0% { -webkit-transform: translate(30px); }
  20% { -webkit-transform: translate(-30px); }
  40% { -webkit-transform: translate(15px); }
  60% { -webkit-transform: translate(-15px); }
  80% { -webkit-transform: translate(8px); }
  100% { -webkit-transform: translate(0px); }
}
@-moz-keyframes kf_shake {
  0% { -moz-transform: translate(30px); }
  20% { -moz-transform: translate(-30px); }
  40% { -moz-transform: translate(15px); }
  60% { -moz-transform: translate(-15px); }
  80% { -moz-transform: translate(8px); }
  100% { -moz-transform: translate(0px); }
}
@-o-keyframes kf_shake {
  0% { -o-transform: translate(30px); }
  20% { -o-transform: translate(-30px); }
  40% { -o-transform: translate(15px); }
  60% { -o-transform: translate(-15px); }
  80% { -o-transform: translate(8px); }
  100% { -o-origin-transform: translate(0px); }
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/modals/AddressSearchUk.vue